import moment from "moment";

export function dateFormatter({ value }: { value: number }): string {
  if (typeof value !== "number" || value < 0) {
    return "";
  }

  const isLikelySeconds = value < 1e12;
  const timestamp = isLikelySeconds ? value * 1000 : value;

  const m = moment(timestamp);
  return m.isValid() ? m.locale(navigator.language || 'en-GB').format('L') : "";
}
